import type { ListCampaignRow } from 'modules/campaign/row';
import { SupplierTitle } from 'modules/supplier/supplier/components';
import { date } from 'components/columns';
import { BoundStates, ClientTitle } from 'components';
import { EnterpriseLink } from 'components/EnterpriseLink';
import { sepFormat } from 'utilities';
import { TableColumns } from '@ff-it/ui';
import { Icon, ActivityIcon } from 'components/Icon';

const sumProps = {
  width: 120,
  cellProps: {
    textAlign: 'end' as const,
  },
};

export const columns: TableColumns<ListCampaignRow> = [
  {
    // content: 'Row',
    key: 'id',
    width: 25,
    cellProps: {
      className: 'px-0 text-center',
    },
    render: ({ id, block: { id: blockId, campaign } }: ListCampaignRow) => (
      <EnterpriseLink to={`/planning/campaigns/${campaign.id}/planning/${blockId}?rowId=${id}`}>
        <Icon size="sm" icon="link" />
      </EnterpriseLink>
    ),
    sortable: false,
  },
  {
    content: 'Block',
    key: 'block.code',
    width: 120,
    render: ({ block: { id, code, campaign } }: ListCampaignRow) => (
      <EnterpriseLink to={`/planning/campaigns/${campaign.id}/planning/${id}`}>{code}</EnterpriseLink>
    ),
    sortable: true,
  },
  {
    width: 30,
    key: 'type',
    render: ({ block: { type } }: ListCampaignRow) => <ActivityIcon type={type} />,
    sortable: false,
    cellProps: {
      textAlign: 'center',
      flush: true,
    },
  },
  {
    content: 'Title',
    key: 'block.title',
    sortable: true,
    render: ({ block: { title, final_client_po_number } }) => (
      <>
        {title}{' '}
        {final_client_po_number && (
          <small className="text-muted" data-testid="client-po-number">
            {final_client_po_number}
          </small>
        )}
      </>
    ),
  },
  {
    content: 'Client',
    key: 'block.client',
    render: ({ block: { campaign } }) => <ClientTitle {...campaign} />,
  },
  {
    content: 'Supplier',
    key: 'supplier',
    cellProps: {
      className: 'py-1',
    },
    render: ({ supplier }) => (supplier ? <SupplierTitle {...supplier} /> : null),
  },
  date('Date from', 'sums.planned.date_from' as any),
  date('Date to', 'sums.planned.date_to' as any),
  {
    ...sumProps,
    content: 'Client total',
    key: 'sums.target.client_net_total',
    render: ({ state, sums }) => sepFormat(!state.canceled ? sums.target.client_net_total : null),
  },
  {
    ...sumProps,
    content: 'Provider total',
    key: 'sums.target.provider_net_total',
    render: ({ state, sums }) => sepFormat(!state.canceled ? sums.target.provider_net_total : null),
  },
  {
    width: 60,
    cellProps: {
      textAlign: 'center',
    },
    key: 'state',
    render: ({ id, state }: ListCampaignRow) => (!state.canceled ? <BoundStates {...state} row={id} /> : null),
  },
  {
    ...sumProps,
    content: 'Revenue',
    key: 'sums.target.revenue',
    render: ({ state, sums }) => sepFormat(!state.canceled ? sums.target.revenue : null),
  },
];
